import React, { Component } from 'react';

import FormulaBar from 'editor/workspace/window/viewer/toolbar/FormulaBar';
import Smoothing from 'editor/workspace/window/viewer/toolbar/Smoothing';

import styles from 'editor/workspace/window/viewer/toolbar/toolBar.module.scss';
import {Context} from "context";

class ToolBar extends Component {
    static contextType = Context;

    render() {
        let xValue = "No Values";

        if (this.props.selection.topLeft.i !== undefined){
            const selected = this.props.table.dataAxis.matrix.extract(this.props.selection.topLeft, this.props.selection.bottomRight);
            xValue = selected.shape.m === 1 && selected.shape.n === 1 ? selected.formatData()[0] : `${selected.shape.m * selected.shape.n} values`;
        }

        return (
            <div className={styles.toolBar}>
                <FormulaBar
                    apply={this.props.apply}
                    window={this.props.window}
                    table={this.props.table}
                    updateFormula={this.props.updateFormula}
                    formula={this.props.formula}
                    xValue={xValue}
                    selection={this.props.selection}
                    selectionFinalised={this.props.selectionFinalised}
                    activateNumberPad={this.props.activateNumberPad}
                    closeNumberPad={this.props.closeNumberPad}
                    numberPad={this.props.numberPad}
                    focused={this.props.focused}
                />
                <Smoothing smooth={this.props.smooth} selection={this.props.selection}/>
            </div>
        )        
    }
}

export default ToolBar;